<template>
  <div class="news-list">
    <BasePage mode="list">
      <div slot="toolBar">
        <el-row>
          <el-col :span="12">
            <el-button
              size="small"
              icon="el-icon-plus"
              @click="add"
              v-access:add
              type="danger"
              >新增</el-button
            >
            <el-button
              size="small"
              icon="el-icon-download"
              @click="exportList"
              v-access:modify
              >导出</el-button
            >
          </el-col>
          <el-col :span="12" style="text=align: right">
            <div class="search-box">
              <el-input
                class="toolBar-search"
                v-model="searchModel.searchKey"
                :placeholder="placeholder"
              />
              <el-button
                size="small"
                icon="el-icon-search"
                type="danger"
                @click="loadData"
                >查询</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>

      <div>
        <el-table
          border
          hightlight-current-row
          style="width: 100%"
          :header-cell-class-name="headerRow"
          :data="donationOrganModel"
          :max-height="tableMaxHeight()"
          v-loading="isloading"
        >
          <el-table-column
            prop="BusinessId"
            label="登记编号"
            width="200"
            align="left"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              {{ scope.row.BusinessId || "-" }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Name"
            label="姓名"
            width="120"
            align="left"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Phone"
            label="捐献者电话"
            width="110"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="IdentityCard"
            label="身份证号码"
            width="170"
            align="center"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="Willingness"
            label="捐献意愿"
            align="left"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column
            prop="CreateTime"
            label="登记时间"
            width="140"
            align="center"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              {{ (scope.row.CreateTime * 1000) | formatDate }}
            </template>
          </el-table-column>
          <el-table-column
            prop="Status"
            label="状态"
            align="center"
            width="80"
            :formatter="statusFormatter"
            :show-overflow-tooltip="true"
          ></el-table-column>
          <el-table-column label="操作" width="130" align="center">
            <template slot-scope="scope">
              <el-button
                v-access:modify
                @click="innerEdit(scope.row)"
                type="text"
                size="mini"
                >编辑</el-button
              >
              <el-button
                v-access:read
                @click="innerRead(scope.row)"
                type="text"
                size="mini"
                >详情</el-button
              >
              <!-- <el-button v-access:read type="text" size="mini">打印</el-button> -->
            </template>
          </el-table-column>
        </el-table>
        <div class="pagination-wapper">
          <OfPagination
            :total="total"
            :pageSize="searchModel.pageSize"
            :currentPage="searchModel.currentPage"
            @onSizeChange="handleSizeChange"
            @onCurrentChange="handleCurrentChange"
          ></OfPagination>
        </div>
      </div>
    </BasePage>
    <ModelEdit
      v-if="editVisible"
      :id="editId"
      @formCallBack="formCallBack"
    ></ModelEdit>
    <ModelQuery
      v-if="queryVisible"
      :id="editId"
      @formCallBack="formCallBack"
    ></ModelQuery>
  </div>
</template>

<script>
import BasePage from "@/components/base/of_page/of_page";
import OfSearch from "@/components/controls/of_search/of_search";
import OfPagination from "@/components/controls/of_pagination/of_pagination";
import ModelEdit from "@/modules/zjrc/pages/donation/donationorgan/edit";
import ModelQuery from "@/modules/zjrc/pages/donation/donationorgan/query";
import api from "@/modules/zjrc/api";
import { saveAs } from "file-saver";

export default {
  name: "list",
  data() {
    return {
      headerRow: "headerRow",
      placeholder: "请输入登记编号 / 姓名",
      donationOrganModel: [],
      isloading: false,
      searchModel: { searchKey: "", currentPage: 1, pageSize: 15 },
      editVisible: false,
      queryVisible: false,
      editId: "",
      total: 0,
    };
  },
  components: {
    BasePage,
    OfSearch,
    OfPagination,
    ModelEdit,
    ModelQuery,
  },
  mounted() {
    let that = this;
    that.loadData();
  },
  methods: {
    //导出
    exportList() {
      const vm = this;
      saveAs(
        "/api/DonationOrgan/ExportDonationOrgan?searchKey=" +
          vm.searchModel.searchKey,
        "遗体器官捐献.xls"
      );
    },
    //新增
    add() {
      const vm = this;
      vm.editId = "";
      vm.editVisible = true;
    },
    //初始化数据
    loadData() {
      let that = this;
      let params = {
        SearchKey: that.searchModel.searchKey,
        PageIndex: that.searchModel.currentPage,
        PageSize: that.searchModel.pageSize,
      };
      that.isloading = true;
      api.QueryDonationOrgan(params).then((res) => {
        if (res.data.Code == 0) {
          that.donationOrganModel = res.data.Data.rows;
          that.total = res.data.Data.total;
        }
        that.isloading = false;
      });
    },
    //列表高度
    tableMaxHeight() {
      var clientHeight = window.innerHeight;
      var tableMaxHeight = 0;
      if (clientHeight && clientHeight !== undefined) {
        tableMaxHeight = clientHeight - 363;
      }
      return tableMaxHeight;
    },
    //搜索框
    search(searchKey) {
      let that = this;
      that.searchModel.searchKey = searchKey;
      this.loadData();
    },
    //状态展示
    statusFormatter(rowData) {
      return rowData.Status == 0 ? "未完成" : "已完成";
    },
    //编辑
    innerEdit(rowData) {
      let that = this;
      that.editId = rowData.Id;
      that.editVisible = true;
    },
    //详情
    innerRead(rowData) {
      let that = this;
      that.editId = rowData.Id;
      that.queryVisible = true;
    },
    formCallBack(data) {
      let that = this;
      that.editVisible = false;
      that.queryVisible = false;
      if (data) {
        that.loadData();
      }
    },
    handleSizeChange(val) {
      this.searchModel.currentPage = 1;
      this.searchModel.pageSize = val;
      this.loadData();
    },
    handleCurrentChange(val) {
      if (this.total > this.searchModel.pageSize) {
        this.searchModel.currentPage = val;
        this.loadData();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.search-box {
  text-align: right;
  .toolBar-search {
    width: 300px;
    margin-right: 10px;
  }
}
</style>